module.exports = __webpack_public_path__ + "img/icon_promotion_off.9f38aee4.svg";